<header class="page-head" data-testid="users-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-users"></i></span>
    <div>
      <h1 class="page-head__title">Usuários</h1>
    </div>
  </div>
  <div class="page-head__actions">
    <a [routerLink]="['/users/new']" class="sf-btn sf-btn--primary" data-testid="link-to-new-user">
      <i class="fa fa-plus-circle"></i> Novo usuário
    </a>
    <button
      *ngIf="isAdmin"
      type="button"
      class="sf-btn sf-btn--secondary"
      (click)="openImportMigrationModal()"
      data-testid="btn-import-call4u"
    >
      <i class="fa fa-cloud-download"></i> Importar do Call4U
    </button>
  </div>
</header>

<div class="filter-bar">
  <div class="search-wrap grow">
    <i class="fa fa-search"></i>
    <input
      type="text"
      name="filter"
      class="form-control"
      placeholder="Digite o nome ou email"
      aria-label="Digite o nome ou email"
      [(ngModel)]="filter"
      (keydown)="filterKeyPress($event)"
      data-testid="input-search-user"
    />
    <button type="button" class="search-go" aria-label="Pesquisar" (click)="pageChanged(page)" data-testid="btn-search-user">
      <i class="fa fa-search"></i>
    </button>
  </div>
  <div class="seg" role="tablist" aria-label="Status">
    <button type="button" role="tab" [class.on]="active === null && promocode === null" [attr.aria-selected]="active === null && promocode === null" (click)="filterByStatus()" data-testid="btn-filter-all">
      Todos
    </button>
    <button type="button" role="tab" [class.on]="active === true" [attr.aria-selected]="active === true" (click)="filterByStatus(true)">
      Ativos
    </button>
    <button type="button" role="tab" [class.on]="active === false" [attr.aria-selected]="active === false" (click)="filterByStatus(false)" data-testid="btn-filter-inactive">
      Inativos
    </button>
    <button type="button" role="tab" [class.on]="!!promocode" [attr.aria-selected]="!!promocode" (click)="filterByStatus(null, true)">
      Promocode
    </button>
  </div>
</div>

<div class="filter-bar filter-bar--selects">
  <div class="field">
    <label for="promocode_filter">Promocode</label>
    <select id="promocode_filter" name="promocode_filter" class="form-select" [(ngModel)]="promocodeId">
      <option value="" selected>Todos</option>
      <option *ngFor="let promotion of promotions" [value]="promotion.promocode">
        {{ promotion.promocode }} ({{ promotion.user_credits }})
      </option>
    </select>
  </div>

  <div class="field">
    <label for="automation_id">Provedor de saída [Automação]</label>
    <select
      name="automation_id"
      id="automation_id"
      class="form-select"
      (change)="filterByAutomation()"
      [(ngModel)]="automationId"
    >
      <option value="">Todas</option>
      <option *ngFor="let provider of providers" [value]="provider.id">
        {{ provider.name }}
      </option>
    </select>
  </div>

  <div class="field">
    <label for="fractionation_group_id">Rota de saída [Broadcast]</label>
    <select
      name="fractionation_group_id"
      id="fractionation_group_id"
      class="form-select"
      (change)="filterByBroadcastFractionationRoute()"
      [(ngModel)]="broadcastFractionationRoute"
    >
      <option value="">Todas</option>
      <option *ngFor="let fractionationGroup of fractionationGroups" [value]="fractionationGroup.id">
        {{ fractionationGroup.name }}
      </option>
    </select>
  </div>

  <div class="field">
    <label for="shortener_id">Encurtador</label>
    <select
      name="shortener_id"
      id="shortener_id"
      class="form-select"
      (change)="filterByShortener()"
      [(ngModel)]="shortenerId"
    >
      <option value="">Todas</option>
      <option *ngFor="let shortener of shorteners" [value]="shortener.id">
        {{ shortener.name }}
      </option>
    </select>
  </div>

  <div class="sort-wrap">
    <select name="order" id="order" class="form-select" [(ngModel)]="orderBy" (change)="orderByChanged()">
      <option value="name">Ordenar por nome</option>
      <option value="created_at">Ordenar por data de cadastro</option>
      <option value="credits">Ordenar por créditos restantes</option>
    </select>
    <button
      type="button"
      class="sf-btn sf-btn--secondary sf-btn--icon"
      [title]="invertedOrder ? 'Ordem crescente (inverter)' : 'Ordem decrescente (inverter)'"
      (click)="invertOrder()"
    >
      <i class="fa" [class.fa-sort-amount-asc]="!invertedOrder" [class.fa-sort-amount-desc]="invertedOrder"></i>
    </button>
  </div>
</div>

<app-skeleton *ngIf="loading" variant="table-row" [count]="6" [columns]="4"
  label="Carregando os usuários" data-testid="users-loading"></app-skeleton>

<div *ngIf="!loading && result?.data.length > 0; else notFound" class="user-list">
  <div class="row-card" *ngFor="let user of result.data" [class.is-active]="user.active" [class.is-inactive]="!user.active" data-testid="user-item">
    <span class="row-avatar"><i class="fa fa-user"></i></span>

    <div class="info">
      <div class="name">
        <span class="title" [ngClass]="user.active ? 'primary' : 'danger'">{{ getTitle(user) }}</span>
      </div>

      <div class="meta-line">
        <span class="meta-chip" data-testid="user-item-email">
          <i class="fa fa-envelope-o"></i> {{ user.email }}
        </span>
        <span class="meta-chip" data-testid="user-item-created-at">
          <i class="fa fa-calendar-o"></i> {{ user.created_at | date : "dd/MM/yyyy, H:mm" }}
        </span>
        <a
          *ngIf="user.phone"
          class="meta-chip"
          href="https://wa.me/{{ user.phone }}?text=Olá {{ user.name }}, aqui é da SMSFunnel."
          target="_blank"
          data-testid="user-item-phone"
        >
          <i class="fa fa-whatsapp"></i> {{ user.phone }}
        </a>
        <span *ngIf="!user.phone" class="meta-chip">
          <i class="fa fa-whatsapp"></i> -
        </span>
        <span
          *ngIf="user.reference_user != null"
          class="meta-chip"
          ngbTooltip="Nome e email do parceiro/agência a qual o usuário é afiliado."
        >
          <i class="fa fa-link"></i> {{ user.reference_user.name }} ({{ user.reference_user.email }})
        </span>
      </div>

      <div class="kpis">
        <ng-container *ngIf="!user.wallet_sms_billed">
          <div class="kpi" data-testid="package-sms-sent">
            <h4><i class="fa fa-paper-plane-o ic"></i> SMS Enviados</h4>
            <b>{{ user.total_sent }}</b>
          </div>
          <div class="kpi" data-testid="package-sms-contracted">
            <h4><i class="fa fa-shopping-cart ic"></i> SMS Contratados</h4>
            <b>{{ user.total_contracted }}</b>
          </div>
          <div class="kpi" data-testid="package-sms-remaining">
            <h4><i class="fa fa-hourglass-half ic"></i> SMS Restantes</h4>
            <b>{{ user.credits }}</b>
          </div>
        </ng-container>

        <ng-container *ngIf="user.wallet_billing_enabled || user.wallet_sms_billed || user.wallet_call_billed">
          <ng-container *ngIf="walletByUser[user.id] as wallet; else walletLoading">
            <ng-container *ngIf="wallet.status === 'ok'; else walletUnavailable">
              <div class="kpi" [class.danger]="wallet.balance.available_micros < 0" data-testid="wallet-available">
                <h4><i class="fa fa-wallet ic"></i> Saldo disponível</h4>
                <b>{{ wallet.balance.available_micros | moneyMicros : wallet.balance.currency : walletBalanceLocale : walletBalanceFractionDigits }}</b>
              </div>
              <div class="kpi" data-testid="wallet-held">
                <h4><i class="fa fa-lock ic"></i> Reservado</h4>
                <b>{{ wallet.balance.held_micros | moneyMicros : wallet.balance.currency : walletBalanceLocale : walletBalanceFractionDigits }}</b>
              </div>
              <div class="kpi" [class.danger]="wallet.balance.balance_micros < 0" data-testid="wallet-total">
                <h4>
                  <i class="fa fa-money ic"></i> Saldo total
                  <span *ngIf="wallet.balance.overdraft" class="text-danger" ngbTooltip="Saldo negativo">⚠</span>
                </h4>
                <b>{{ wallet.balance.balance_micros | moneyMicros : wallet.balance.currency : walletBalanceLocale : walletBalanceFractionDigits }}</b>
              </div>
              <!-- Custo de cada canal (subtask 17tm466vyfb, pedido do Misael em 30/10): preço atual do
                   cliente na unidade do canal e gasto do mês. Ocupa a linha inteira dos KPIs. -->
              <details class="kpi kpi--channels" data-testid="wallet-channels">
                <summary><i class="fa fa-exchange ic"></i> Cobrado pela carteira <i class="fa fa-chevron-down channel-costs__chevron" aria-hidden="true"></i></summary>
                <ng-container *ngIf="walletCostsByUser[user.id] as costs; else walletCostsLoading">
                  <ng-container *ngIf="costs.status === 'ok' && costs.channels.length > 0; else walletCostsFallback">
                    <div class="channel-costs__head" aria-hidden="true">
                      <span>Canal</span><span>Preço atual</span><span>Gasto {{ walletCostsPeriod(costs) }}</span>
                    </div>
                    <ul class="channel-costs" data-testid="wallet-channel-costs">
                      <li *ngFor="let cost of costs.channels" class="channel-cost" [attr.data-testid]="'wallet-channel-' + cost.channel">
                        <span class="channel-cost__name">
                          <i class="fa {{ walletChannelIcon(cost.channel) }}" aria-hidden="true"></i>
                          {{ walletChannelLabel(cost.channel) }}
                        </span>
                        <span class="channel-cost__price" [ngbTooltip]="walletChannelPriceHint(cost)"
                          [attr.aria-label]="walletChannelPriceHint(cost)" [attr.data-testid]="'wallet-channel-price-' + cost.channel">
                          {{ walletChannelPrice(cost) }}<small *ngIf="walletChannelPrice(cost) !== '—'">{{ walletChannelUnit(cost) }}</small>
                        </span>
                        <span class="channel-cost__spent" [attr.data-testid]="'wallet-channel-spent-' + cost.channel">
                          {{ walletChannelSpent(cost) }}
                        </span>
                      </li>
                    </ul>
                    <small *ngIf="costs.partial" class="channel-costs__note" data-testid="wallet-channel-costs-partial">
                      Parte dos valores não veio da carteira agora (—).
                    </small>
                  </ng-container>
                  <ng-template #walletCostsFallback>
                    <b class="small-value">{{ walletChargedChannels(wallet.billing) }}</b>
                    <small *ngIf="costs.status !== 'ok'" data-testid="wallet-channel-costs-unavailable">Custos indisponíveis agora</small>
                  </ng-template>
                </ng-container>
                <ng-template #walletCostsLoading>
                  <b class="small-value">{{ walletChargedChannels(wallet.billing) }}</b>
                  <small data-testid="wallet-channel-costs-loading">Carregando custos…</small>
                </ng-template>
              </details>
            </ng-container>
            <ng-template #walletUnavailable>
              <div class="kpi" data-testid="wallet-unavailable">
                <h4><i class="fa fa-wallet ic"></i> Carteira</h4>
                <b class="small-value">Carteira indisponível agora</b>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #walletLoading>
            <div class="kpi" data-testid="wallet-loading">
              <h4><i class="fa fa-wallet ic"></i> Carteira</h4>
              <b>…</b>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <div class="icon-group">
      <a
        class="sf-btn sf-btn--primary sf-btn--icon sf-btn--sm"
        [routerLink]="['/users/edit', user.id]"
        ngbTooltip="Editar"
        aria-label="Editar"
        data-testid="btn-edit-user"
      >
        <i class="fa fa-pencil"></i>
      </a>
      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
        ngbTooltip="Adicionar créditos"
        aria-label="Adicionar créditos"
        [routerLink]="['/recharges/add', user.id]"
      >
        <i class="fa fa-plus"></i>
      </button>
      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
        [ngbTooltip]="user.validated ? 'Remover validação' : 'Validar'"
        [attr.aria-label]="user.validated ? 'Remover validação' : 'Validar'"
        (click)="user.validated ? validate(user, false) : validate(user, true)"
        *ngIf="activeUser?.id !== user.id"
      >
        <i class="fa" [ngClass]="{ 'fa-check': !user.validated, 'fa-times': user.validated }"></i>
      </button>
      <button
        type="button"
        class="sf-btn sf-btn--ghost sf-btn--sm"
        ngbTooltip="Visualizar painel da conta"
        (click)="simulate(user)"
        *ngIf="loggedInUser.id != user.id"
        data-testid="btn-user-viewer"
      >
        <i class="fa fa-user"></i> Visualizar conta do usuário
      </button>
    </div>
  </div>
</div>

<ng-template #notFound>
  <!-- `!loading` para o vazio não piscar antes da primeira resposta. -->
  <div class="sf-card empty" *ngIf="!loading" data-testid="users-empty">
    <i class="fa fa-users"></i>
    <p>Nenhuma usuário cadastrado</p>
  </div>
</ng-template>

<app-pagination
  *ngIf="!loading && result"
  look="v2"
  [currentPage]="result.current_page"
  [itemsPerPage]="result.per_page"
  [totalItems]="result.total"
  (pageChanged)="pageChanged($event)"
></app-pagination>

<ng-template #importMigrationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="importMigrationTitle">
      <i class="fa fa-cloud-download"></i> Importar cliente do Call4U
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <ol class="stepper">
      <li [class.on]="importStep === 'select'" [class.done]="importStep === 'review'">
        <span class="n">1</span>
        <span class="lbl">Selecione o dump</span>
        <span class="line"></span>
      </li>
      <li [class.on]="importStep === 'review'">
        <span class="n">2</span>
        <span class="lbl">Confirme os dados</span>
      </li>
    </ol>

    <!-- Step 1: seleção de dump -->
    <div *ngIf="importStep === 'select'">
      <div class="alert alert-warning">
        Esta ação carrega o dump do cliente exportado pelo Call4U e cria/atualiza
        a conta no SMS Funnel. Confirme o e-mail e selecione o dump correto.
      </div>

      <div class="field">
        <label for="importEmailInput">E-mail do cliente no Call4U</label>
        <input
          id="importEmailInput"
          type="email"
          class="form-control"
          [(ngModel)]="importEmail"
          (input)="onImportEmailChange()"
          placeholder="email@cliente.com"
          data-testid="input-import-email"
        />
      </div>

      <div *ngIf="importLoadingDumps" class="text-center my-3">
        <i class="fa fa-spinner fa-spin"></i> Buscando dumps no S3...
      </div>

      <div
        *ngIf="!importLoadingDumps && importSearchError"
        class="alert alert-danger"
        data-testid="import-search-error"
      >
        <i class="fa fa-exclamation-triangle me-1"></i>
        Falha na busca de dumps: {{ importSearchError }}
      </div>

      <div
        *ngIf="!importLoadingDumps && !importSearchError && importLastSearchedEmail && importDumps.length === 0"
        class="alert alert-secondary"
      >
        Nenhum dump encontrado no S3 para <b>{{ importLastSearchedEmail }}</b>.
        Confirme se o export rodou no Call4U.
      </div>

      <div *ngIf="importDumps.length > 0">
        <label class="d-block mb-2">Selecione o dump:</label>
        <div *ngFor="let dump of importDumps; trackBy: trackByDumpPrefix" class="pick" [class.on]="dump.s3_prefix === importSelectedPrefix">
          <input
            class="form-check-input"
            type="radio"
            name="dumpSelection"
            [id]="'dump-' + dump.s3_prefix"
            [value]="dump.s3_prefix"
            [(ngModel)]="importSelectedPrefix"
          />
          <label class="form-check-label" [for]="'dump-' + dump.s3_prefix">
            <b>{{ dump.exported_at | date: 'dd/MM/yyyy HH:mm' }}</b>
            (call4u_user_id: {{ dump.call4u_user_id }}, saldo: {{ dump.balance }})
            <span *ngIf="dump.imported" class="meta-chip ms-1">já importado</span>
            <br />
            <small class="text-muted">{{ dump.s3_prefix }}</small>
          </label>
        </div>
      </div>
    </div>

    <!-- Step 2: review com counts -->
    <div *ngIf="importStep === 'review' && importSelectedDump">
      <div class="alert alert-info">
        <i class="fa fa-info-circle me-1"></i>
        Confirme os dados antes de enfileirar a importação. Esta ação cria ou
        atualiza o usuário no SMS Funnel V2 e credita o saldo do Call4U.
      </div>

      <dl class="def-grid">
        <div class="def">
          <dt>E-mail</dt>
          <dd>{{ importEmail }}</dd>
        </div>
        <div class="def">
          <dt>call4u_user_id</dt>
          <dd>{{ importSelectedDump.call4u_user_id }}</dd>
        </div>
        <div class="def">
          <dt>Exportado em</dt>
          <dd>{{ importSelectedDump.exported_at | date: 'dd/MM/yyyy HH:mm' }}</dd>
        </div>
        <div class="def">
          <dt>Saldo a creditar</dt>
          <dd><b>{{ importSelectedDump.balance }}</b> créditos</dd>
        </div>
        <div class="def wide">
          <dt>Conteúdo do dump</dt>
          <dd>
            <span *ngFor="let key of (importSelectedDump.counts | keyvalue); trackBy: trackByCountKey" class="meta-chip me-1">
              {{ key.key }}: {{ key.value }}
            </span>
          </dd>
        </div>
        <div class="def wide">
          <dt>S3 Prefix</dt>
          <dd><code>{{ importSelectedDump.s3_prefix }}</code></dd>
        </div>
      </dl>

      <div *ngIf="importSelectedDump.imported" class="alert alert-warning" data-testid="import-already-imported">
        <i class="fa fa-exclamation-triangle me-1"></i>
        <strong>Este dump já foi importado.</strong> Reimportar pode duplicar
        operações ou alterar saldo. O backend vai retornar 409 a menos que você
        marque a opção abaixo.
        <div class="form-check mt-2">
          <input
            type="checkbox"
            class="form-check-input"
            id="importForceCheckbox"
            [(ngModel)]="importForce"
            data-testid="checkbox-import-force"
          />
          <label for="importForceCheckbox" class="form-check-label">
            Reimportar mesmo assim (force=true)
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.dismiss()" [disabled]="importSubmitting">
      Cancelar
    </button>

    <button
      *ngIf="importStep === 'select'"
      type="button"
      class="sf-btn sf-btn--primary"
      (click)="goToImportReview()"
      [disabled]="!importSelectedPrefix"
      data-testid="btn-import-next"
    >
      Próximo <i class="fa fa-arrow-right ms-1"></i>
    </button>

    <ng-container *ngIf="importStep === 'review'">
      <button
        type="button"
        class="sf-btn sf-btn--secondary"
        (click)="backToImportSelect()"
        [disabled]="importSubmitting"
      >
        <i class="fa fa-arrow-left me-1"></i> Voltar
      </button>
      <button
        type="button"
        class="sf-btn sf-btn--primary"
        (click)="confirmImportMigration()"
        [disabled]="importSubmitting || (importSelectedDump?.imported && !importForce)"
        data-testid="btn-confirm-import"
      >
        <i class="fa" [class.fa-spinner]="importSubmitting" [class.fa-spin]="importSubmitting" [class.fa-cloud-download]="!importSubmitting"></i>
        Confirmar importação
      </button>
    </ng-container>
  </div>
</ng-template>
